
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Hondacityonrentinpune() {



  const cardData =
  {
    keyword: 'Honda City On Rent in Pune',
    heading: 'SHREE Tours & Travels: Honda City On Rent in Pune',
    headingDescription: 'SHREE Tours & Travels offers Honda City on rent in Pune, providing a premium and comfortable travel experience for business trips, airport transfers, outstation travel and family outings. Our well-maintained Honda City ensures a smooth and luxurious ride with professional drivers, on-time service and competitive pricing. Whether you need a one-way Cab or a round-trip journey, we guarantee a hassle-free travel experience. Choose SHREE Tours & Travels for the best Honda City rental service in Pune.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in Pune, Shaniwar Wada was once the seat of the Peshwas of the Maratha Empire. Built in 1732, this grand structure features intricate wooden architecture, massive gates and the famous 'Delhi Darwaza.' It is surrounded by gardens and fountains, making it a great spot for history enthusiasts. The light and sound show in the evening narrates the fort's rich history, adding to the experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is an architectural masterpiece and a symbol of India's freedom struggle. It served as a prison for Mahatma Gandhi and other freedom fighters during the Quit India Movement. The palace features Italian arches, sprawling gardens and a museum housing personal belongings of Mahatma Gandhi, making it a must-visit for history and heritage lovers."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Perched atop a hill, Sinhagad Fort is one of Pune’s most famous trekking destinations. This historic fortress, associated with the Maratha warrior Tanaji Malusare, offers breathtaking views of the Sahyadri mountains. Visitors can explore the ancient ruins, enjoy local delicacies like 'pithla bhakri,' and experience the fort’s rich history while trekking through its scenic trails."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of Pune’s most revered temples, Dagdusheth Halwai Ganpati Temple is dedicated to Lord Ganesha. Known for its grand Ganesh idol adorned with gold ornaments, the temple attracts thousands of devotees daily. The temple’s annual Ganesh festival is a grand spectacle, featuring magnificent decorations, cultural performances and a spiritual ambiance."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "A fascinating museum housing over 20,000 artifacts, the Raja Dinkar Kelkar Museum showcases a diverse collection of sculptures, paintings, musical instruments and everyday objects from India’s past. The museum is particularly known for its replica of the Mastani Mahal, which provides a glimpse into the royal lifestyle of the Peshwas."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "Carved out of a single rock in the 8th century, the Pataleshwar Cave Temple is dedicated to Lord Shiva. This ancient temple, featuring massive stone pillars and intricate carvings, is a peaceful retreat amidst Pune’s bustling city life. The temple’s unique architecture and serene atmosphere make it a hidden gem for history and spirituality seekers."
    },
    {
        "title": "Pashan Lake",
        "description": "Pashan Lake is a beautiful artificial lake, ideal for nature lovers and bird watchers. Surrounded by lush greenery, the lake serves as a habitat for various migratory birds. The walking track along the lake makes it a perfect spot for morning walks, photography and peaceful relaxation away from the city’s hustle."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned spiritual center promoting meditation and wellness. Visitors can experience a range of meditation techniques, yoga sessions and rejuvenation therapies. The ashram's lush gardens, serene atmosphere and international community make it a unique place for self-discovery and relaxation."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal is a historic site closely associated with Chhatrapati Shivaji Maharaj, as it was his childhood residence. Though rebuilt, the palace features paintings and exhibits depicting Shivaji’s life and achievements. The site is of great historical importance and offers insights into the Maratha legacy."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Situated on the outskirts of Pune, Khadakwasla Dam is a popular picnic spot offering scenic views and a refreshing escape. The dam is a great place for photography, evening walks and enjoying street food like corn and chai. The nearby Sinhagad Fort and Panshet Dam make it a perfect getaway for adventure seekers and nature lovers."
    }
],  
    
            
"services": [
    {
      "name": "Honda City Rental Pune",
      "description": "Rent a Honda City in Pune for a comfortable and stylish ride. Ideal for local travel, outstation trips and corporate events, the Honda City provides excellent fuel efficiency and a smooth driving experience."
    },
    {
      "name": "Rent Honda City in Pune",
      "description": "Looking for a reliable rental car in Pune? Rent a Honda City for its premium features, comfortable seating and smooth performance. It’s the perfect car for a variety of travel needs, whether local or outstation."
    },
    {
      "name": "Affordable Honda City Car Hire",
      "description": "Get affordable Honda City rental services in Pune without compromising on comfort or quality. Whether for a business trip or a family outing, enjoy a spacious ride at a competitive price."
    },
    {
      "name": "Honda City Taxi Hire Pune",
      "description": "Hire a Honda City taxi in Pune for a luxurious yet affordable travel experience. Whether you need it for local trips, outstation journeys, or airport pickups, the Honda City ensures a smooth ride."
    },
    {
      "name": "Honda City for Outstation Travel Pune",
      "description": "Planning an outstation trip from Pune? Rent a Honda City for a comfortable, efficient and enjoyable journey. Its spacious interiors and powerful engine make it perfect for long-distance travel."
    },
    {
      "name": "Rent Honda City for Local Travel in Pune",
      "description": "Rent a Honda City for your local travel in Pune. Whether it's a day of sightseeing, shopping, or attending meetings, the Honda City offers a comfortable and convenient ride."
    },
    {
      "name": "Book Honda City for Family Trip",
      "description": "Looking for a family-friendly rental in Pune? Rent a Honda City for your family trip. With spacious seating and ample luggage space, it’s the ideal car for family outings or vacations."
    },
    {
      "name": "Honda City for Airport Pickup Pune",
      "description": "Need an airport pickup in Pune? Book a Honda City for a comfortable and stylish ride to or from the airport. Enjoy a smooth and hassle-free journey with professional drivers."
    },
    {
      "name": "Honda City Hire for Corporate Travel Pune",
      "description": "Rent a Honda City for your corporate travel needs in Pune. Offering a mix of luxury and practicality, it’s perfect for business meetings, conferences and corporate events, ensuring comfort and professionalism."
    },
    {
      "name": "Honda City Hire for Group Travel Pune",
      "description": "Traveling with a group? Rent a Honda City for group travel within Pune. With ample space and comfort, it’s perfect for small groups looking to travel together with ease and style."
    },
    {
      "name": "Book Honda City for Pune to Outstation Trip",
      "description": "Book a Honda City for your outstation trip from Pune. Whether it’s a weekend getaway or a business trip, the Honda City ensures a smooth and comfortable journey with ample space and luxury."
    },
    {
      "name": "Luxury Honda City Car Hire Pune",
      "description": "Indulge in luxury with our Honda City car hire in Pune. Whether for a business trip, family outing, or personal travel, the Honda City offers a premium experience with modern features and comfortable seating."
    },
    {
      "name": "Honda City for Business Travel Pune",
      "description": "Book a Honda City for your business travel in Pune. Perfect for meetings, conferences and airport transfers, it combines style, comfort and efficiency for a professional experience."
    }
  ],
  "tableData": [
    ["- Honda City Rental Pune", "- Rent Honda City in Pune"],
    ["- Affordable Honda City Car Hire", "- Honda City Taxi Hire Pune"],
    ["- Honda City for Outstation Travel Pune", "- Rent Honda City for Local Travel in Pune"],
    ["- Book Honda City for Family Trip", "- Honda City for Airport Pickup Pune"],
    ["- Honda City Hire for Corporate Travel Pune", "- Honda City Hire for Group Travel Pune"],
    ["- Book Honda City for Pune to Outstation Trip", "- Luxury Honda City Car Hire Pune"],
    ["- Honda City for Business Travel Pune"]
  ],


  whychoose: [
    {
      "WhyChooseheading": "Stylish and Comfortable Ride",
      "WhyChoosedescription": "The Honda City offers a perfect blend of style, comfort and performance. Known for its sleek design, spacious interior and smooth ride, it’s an ideal choice for both business and leisure travel in Pune. Whether you're going for a meeting or a vacation, the Honda City ensures a premium experience."
    },
    {
      "WhyChooseheading": "Affordable Luxury",
      "WhyChoosedescription": "We offer the Honda City at competitive rental rates, making it a great choice for those who seek luxury at an affordable price. Get a premium driving experience without breaking the bank and enjoy the perfect balance of cost-effectiveness and comfort with our rental options."
    },
    {
      "WhyChooseheading": "Well-Maintained and Clean Vehicles",
      "WhyChoosedescription": "All our Honda City vehicles are regularly serviced and maintained to the highest standards. We ensure that each car is thoroughly cleaned, well-inspected and ready to provide a safe, smooth and comfortable ride for your trip in Pune and beyond."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced, professional and knowledgeable about the best routes around Pune. They focus on your safety, comfort and punctuality, ensuring you enjoy a smooth and stress-free journey. With their friendly demeanor, they will make your trip even more pleasant."
    },
    {
      "WhyChooseheading": "Perfect for Business and Personal Travel",
      "WhyChoosedescription": "The Honda City is perfect for business travelers, families and tourists alike. Whether you need a car for an important business meeting or for a weekend getaway, the Honda City offers the perfect combination of luxury and practicality, making it ideal for all occasions."
    },
    {
      "WhyChooseheading": "Easy and Quick Booking Process",
      "WhyChoosedescription": "Booking the Honda City with SHREE Tours & Travels is quick and hassle-free. You can easily make a reservation through our user-friendly online platform, or contact our customer service team for personalized assistance. We ensure a smooth booking experience every time."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for Honda City rentals in Pune, ensuring you can book a ride at any time that suits your travel schedule. Whether it’s a last-minute trip or a pre-planned journey, we are always available to accommodate your needs."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, customer satisfaction is our top priority. We strive to deliver exceptional service for every Honda City rental, ensuring that your ride is comfortable, safe and punctual. With our dedication to quality service, we guarantee a seamless and enjoyable travel experience."
    }
  ]
  
  
  
  
  

  
  



        
  }
  const faqData = [
    {
        question: "How can I rent a Honda City in Pune?",
        answer: "You can easily rent a Honda City in Pune through our website or by contacting our customer service for assistance."
    },
    {
        question: "What is the rental rate for the Honda City in Pune?",
        answer: "The rental rate for the Honda City varies depending on the duration and type of trip. Please contact us for detailed pricing information."
    },
    {
        question: "Is the rental rate for the Honda City inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. We provide detailed pricing information during the booking process."
    },
    {
        question: "Can I rent a Honda City for a one-way trip in Pune?",
        answer: "Yes, we offer one-way rental options for the Honda City for trips within Pune or to nearby cities."
    },
    {
        question: "Do you provide drivers with the Honda City rental in Pune?",
        answer: "Yes, all our Honda City rentals come with experienced drivers who are familiar with the local routes to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for Honda City bookings in Pune?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for renting a Honda City in Pune?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the Honda City vehicles insured for safety during trips in Pune?",
        answer: "Yes, all our Honda City vehicles are fully insured for your safety and peace of mind during the journey."
    },
    {
        question: "Can I request a child seat for my Honda City rental in Pune?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for renting a Honda City in Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'I rented a Honda City from SHREE Tours & Travels for a family trip in Pune. The car was spacious, clean and the driver was courteous and professional.',
        name: 'Mr. Rahul Deshmukh',
    },
    {
        text: 'The Honda City rental service from SHREE Tours & Travels was excellent. The car was comfortable and the entire journey was smooth and enjoyable.',
        name: 'Miss. Sneha Patil',
    }
];















  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Rent a Honda City in Pune for affordable and luxurious travel. We offer Honda City car rentals for local travel, outstation trips, airport transfers, family trips, group travel, corporate events and more. Call +91 9594917913 to book!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/honda-city-rental.jpg",
    "https://shreetoursandtravels.in/img/honda-city-outstation.jpg"
  ],
  "priceRange": "₹2500 - ₹6000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/honda-city-hire-pune",
    "priceCurrency": "INR",
    "price": 3500,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.8,
    "reviewCount": 850
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Ravi Kumar"
      },
      "datePublished": "2024-07-18",
      "reviewBody": "The Honda City was an excellent choice for our business trip to Mumbai. Comfortable, spacious and reliable. Great service!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Priya Deshmukh"
      },
      "datePublished": "2024-08-25",
      "reviewBody": "Booked Honda City for a family trip to Mahabaleshwar. The car was very comfortable and clean. Amazing experience overall!"
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Honda City Hire Service in Pune",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5204,  // Pune latitude
      "longitude": 73.8567  // Pune longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/honda-city-hire-pune"
  },
  "keywords": "Honda City Rental Pune, Rent Honda City in Pune, Affordable Honda City Car Hire, Honda City Taxi Hire Pune, Honda City for Outstation Travel Pune, Rent Honda City for Local Travel in Pune, Book Honda City for Family Trip, Honda City for Airport Pickup Pune, Honda City Hire for Corporate Travel Pune, Honda City Hire for Group Travel Pune, Book Honda City for Pune to Outstation Trip, Luxury Honda City Car Hire Pune, Honda City for Business Travel Pune"
};




  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Honda City Hire in Pune | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Rent a Honda City in Pune for affordable and luxurious travel. We offer Honda City car rentals for local travel, outstation trips, airport transfers, family trips, group travel, corporate events and more. Call +91 9594917913 to book!" />
  <meta name="keywords" content="Honda City Rental Pune, Rent Honda City in Pune, Affordable Honda City Car Hire, Honda City Taxi Hire Pune, Honda City for Outstation Travel Pune, Rent Honda City for Local Travel in Pune, Book Honda City for Family Trip, Honda City for Airport Pickup Pune, Honda City Hire for Corporate Travel Pune, Honda City Hire for Group Travel Pune, Book Honda City for Pune to Outstation Trip, Luxury Honda City Car Hire Pune, Honda City for Business Travel Pune" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>
    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/25.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Hondacityonrentinpune;